module.exports = __webpack_public_path__ + "static/media/bell@2x.8fe0a5af.png";